import { useTranslation } from "react-i18next";
import type { BookingScheduleInterface } from "../../../../../features/Booking-Form/typings/booking.types";
import { resolveResourceBookingDeliveryStatus } from "../../../../../features/Schedule/utils/resource-booking-schedule.utils";
import { ScheduleResourceBookingMetaField } from "./ScheduleResourceBookingMetaField.partial";

type ScheduleResourceBookingDeliveryStatusProps = Readonly<{
  schedule: BookingScheduleInterface;
}>;

export function ScheduleResourceBookingDeliveryStatus({
  schedule
}: ScheduleResourceBookingDeliveryStatusProps) {
  const { t } = useTranslation();
  const deliveryStatus = resolveResourceBookingDeliveryStatus(schedule);

  if (deliveryStatus == null) {
    return null;
  }

  return (
    <ScheduleResourceBookingMetaField
      label={t("Order")}
      testId="schedule-resource-booking-delivery-status"
    >
      {t(deliveryStatus)}
    </ScheduleResourceBookingMetaField>
  );
}
